import { Node_Type } from "./../../../../../ricos-schema/legacy/wix/rich_content/v1";
import { fromExternalNode } from "./fromExternalNode";
const SPECIAL_CONVERTERS = {
  [Node_Type.EXTERNAL]: fromExternalNode
};
const getPluginRenderers = (context, typeMappers, nodeViewRenderers, SpoilerViewerWrapper) => {
  const convertedTypeMappers = Object.entries(typeMappers).reduce(
    (renderers, [type, pluginComponent]) => {
      return {
        ...renderers,
        ...SPECIAL_CONVERTERS[type]?.({ pluginComponent, type, context, SpoilerViewerWrapper })
      };
    },
    {}
  );
  return { ...convertedTypeMappers, ...nodeViewRenderers };
};
export {
  getPluginRenderers
};
//# sourceMappingURL=getPluginRenderers.js.map
